import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { apiFetch } from '../lib/api';
import { APP_STATUSES, APP_LABELS, appPill, postingPill, LINK, fmt } from '../lib/hiring';
import { reasonList, SPAM_PILL } from '../lib/spamReasons'; // @@FORM_SPAM_v96@@
import { CopyButton } from './HiringShare'; // @@JOB_SHARE_v111@@

// @@JOBS_v86@@ HQ › Hiring — applicants from xyzmerch.com/jobs + the postings.
// Admin/manager only (route-guarded in App.js; the server re-checks).
export default function Hiring() {
  const navigate = useNavigate();
  const [tab, setTab] = useState('applicants');
  const [apps, setApps] = useState(null);
  const [postings, setPostings] = useState(null);
  const [filter, setFilter] = useState({ status: '', posting_id: '' });
  const [view, setView] = useState('inbox'); // @@FORM_SPAM_v96@@ inbox | spam
  const [counts, setCounts] = useState(null);
  const [msg, setMsg] = useState('');
  const [newTitle, setNewTitle] = useState('');

  async function loadPostings() {
    const res = await apiFetch('/api/jobs/postings');
    const d = await res.json().catch(() => ({}));
    if (res.ok) setPostings(d.postings || []); else setMsg(d.error || 'Could not load postings.');
  }
  async function loadApps() {
    const q = new URLSearchParams();
    if (filter.status) q.set('status', filter.status);
    if (filter.posting_id) q.set('posting_id', filter.posting_id);
    if (view === 'spam') q.set('view', 'spam');
    const res = await apiFetch('/api/jobs/applications' + (q.toString() ? '?' + q : ''));
    const d = await res.json().catch(() => ({}));
    if (res.ok) { setApps(d.applications || []); setCounts(d.counts || null); } else setMsg(d.error || 'Could not load applicants.');
  }
  useEffect(() => { loadPostings(); }, []);
  useEffect(() => { loadApps(); }, [filter.status, filter.posting_id, view]);

  async function markAllRead() {
    await apiFetch('/api/jobs/applications/seen', { method: 'POST' });
    loadApps(); loadPostings();
  }
  async function create(e) {
    e.preventDefault();
    if (!newTitle.trim()) return;
    const res = await apiFetch('/api/jobs/postings', {
      method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ title: newTitle.trim() }),
    });
    const d = await res.json().catch(() => ({}));
    if (res.ok) navigate('/hiring/postings/' + d.posting.id); else setMsg(d.error || 'Could not create the posting.');
  }

  const unseen = view === 'inbox' ? (apps || []).filter((a) => !a.seen_at).length : 0;
  // @@FORM_SPAM_v96@@
  const suspects = view === 'inbox' ? (apps || []).filter((a) => a.suspect && a.suspect.length).length : 0;
  async function bulk(path, method, done) {
    setMsg('');
    const res = await apiFetch(path, { method });
    const d = await res.json().catch(() => ({}));
    setMsg(res.ok ? done(d) : (d.error || 'That did not work.'));
    loadApps(); loadPostings();
  }
  const tabBtn = (key, label) => (
    <button key={key} type="button" role="tab" aria-selected={tab === key} onClick={() => setTab(key)}
      style={{ height: 42, padding: '0 14px', background: 'none', border: 0, borderBottom: tab === key ? '2px solid #31b44b' : '2px solid transparent', color: tab === key ? 'var(--hq-txt)' : 'var(--hq-muted)', font: 'inherit', fontSize: 14, cursor: 'pointer' }}>
      {label}
    </button>
  );

  return (
    <div className="hq-page-content">
      <div className="hq-page-head">
        <h1>Hiring</h1>
        <p>Applications from the Careers page on xyzmerch.com. Each new one also emails admins and managers.</p>
      </div>
      {msg && <p className="hq-msg" style={{ marginTop: -12, marginBottom: 16 }}>{msg}</p>}

      <div role="tablist" style={{ display: 'flex', flexWrap: 'wrap', gap: 4, borderBottom: '1px solid var(--hq-line)', marginBottom: 20 }}>
        {tabBtn('applicants', `Applicants${counts ? ` (${counts.inbox})` : ''}`)}
        {tabBtn('postings', `Postings${postings ? ` (${postings.length})` : ''}`)}
      </div>

      {tab === 'applicants' && (
        <div className="hq-panel">
          <div className="hq-panel-head" style={{ flexWrap: 'wrap', gap: 10 }}>
            <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
              {[['inbox', 'Inbox'], ['spam', 'Spam']].map(([k, l]) => ( /* @@FORM_SPAM_v96@@ */
                <button key={k} type="button" aria-pressed={view === k} className={view === k ? 'hq-btn' : 'hq-signout'}
                  style={{ width: 'auto', height: 38, padding: '0 14px', marginTop: 0 }} onClick={() => setView(k)}>
                  {l}{counts ? ` (${k === 'inbox' ? counts.inbox : counts.spam})` : ''}
                </button>
              ))}
              <select className="hq-select" aria-label="Filter by status" value={filter.status} onChange={(e) => setFilter({ ...filter, status: e.target.value })}>
                <option value="">All statuses</option>
                {APP_STATUSES.map((s) => <option key={s} value={s}>{APP_LABELS[s]}</option>)}
              </select>
              <select className="hq-select" aria-label="Filter by posting" value={filter.posting_id} onChange={(e) => setFilter({ ...filter, posting_id: e.target.value })}>
                <option value="">All postings</option>
                {(postings || []).map((p) => <option key={p.id} value={p.id}>{p.title}</option>)}
              </select>
            </div>
            <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
              {unseen > 0 && <button type="button" className="hq-signout" style={{ width: 'auto', padding: '0 14px', marginTop: 0 }} onClick={markAllRead}>Mark all read</button>}
              {suspects > 0 && <button type="button" className="hq-signout" style={{ width: 'auto', padding: '0 14px', marginTop: 0, color: '#ff8c86' }}
                onClick={() => bulk('/api/jobs/applications/spam-suspected', 'POST', (d) => `Moved ${d.moved} to spam.`)}>Move {suspects} that look like spam</button>}
              {view === 'spam' && apps && apps.length > 0 && <button type="button" className="hq-signout" style={{ width: 'auto', padding: '0 14px', marginTop: 0, color: '#ff7a73' }}
                onClick={() => { if (window.confirm(`Delete all ${apps.length} spam applications for good?`)) bulk('/api/jobs/applications/spam', 'DELETE', (d) => `Deleted ${d.deleted}.`); }}>Empty spam</button>}
            </div>
          </div>
          <div style={{ overflowX: 'auto' }}>
            <table className="hq-table" style={{ minWidth: 760 }}>
              <thead><tr><th>Applied</th><th>Name</th><th>Role</th><th>Based in</th><th>Favorite artist / first answer</th><th>Status</th></tr></thead>
              <tbody>
                {(apps || []).map((a) => (
                  <tr key={a.id} style={{ cursor: 'pointer' }} onClick={() => navigate('/hiring/applicants/' + a.id)}>
                    <td style={{ whiteSpace: 'nowrap', color: 'var(--hq-muted)', fontSize: 13 }}>
                      {fmt(a.created_at)}{!a.seen_at && <span style={{ ...appPill('new'), marginLeft: 8 }}>unread</span>}
                    </td>
                    <td><Link to={'/hiring/applicants/' + a.id} style={{ ...LINK, fontWeight: a.seen_at ? 400 : 700 }} onClick={(e) => e.stopPropagation()}>{a.name}</Link>
                      <div style={{ color: 'var(--hq-muted)', fontSize: 12 }}>{a.email}</div>
                      {a.has_resume && <div style={{ color: 'var(--hq-muted)', fontSize: 12 }}>Resume attached</div>}{/* @@JOB_RESUME_v113@@ */}
                      {view === 'spam' && <div style={{ color: '#ff8c86', fontSize: 12, marginTop: 4, maxWidth: 260, whiteSpace: 'normal' }}>{reasonList(a.spam_reasons)}</div>}
                      {a.suspect && a.suspect.length > 0 && <div style={{ marginTop: 6 }}><span style={SPAM_PILL} title={reasonList(a.suspect)}>Looks like spam</span></div>}</td>
                    <td>{a.posting_title}</td>
                    <td>{a.city || '—'}</td>
                    <td style={{ maxWidth: 280, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', fontSize: 13 }}>{a.first_answer || '—'}</td>
                    <td><span style={appPill(a.status)}>{APP_LABELS[a.status] || a.status}</span></td>
                  </tr>
                ))}
                {apps && apps.length === 0 && <tr><td className="hq-empty" colSpan={6}>{view === 'spam' ? 'Nothing in spam. The filter puts suspected bot applications here (no email is sent for them); spam is deleted after 30 days.' : <>No applicants{filter.status || filter.posting_id ? ' match these filters' : ' yet'}.</>}</td></tr>}
                {apps === null && <tr><td className="hq-empty" colSpan={6}>Loading…</td></tr>}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {tab === 'postings' && (
        <>
          <form className="hq-panel" style={{ marginBottom: 16 }} onSubmit={create}>
            <div className="hq-panel-head"><h2>New posting</h2></div>
            <div style={{ padding: 20, display: 'flex', gap: 10, flexWrap: 'wrap' }}>
              <input className="hq-input" style={{ flex: '1 1 280px' }} placeholder="Job title, e.g. Fulfillment Lead" aria-label="Job title"
                value={newTitle} maxLength={80} onChange={(e) => setNewTitle(e.target.value)} />
              <button className="hq-btn" type="submit" disabled={!newTitle.trim()}>Create draft</button>
            </div>
          </form>
          <div className="hq-panel">
            <div style={{ overflowX: 'auto' }}>
              <table className="hq-table" style={{ minWidth: 640 }}>
                <thead><tr><th>Posting</th><th>Status</th><th>Applicants</th><th>Scans</th><th>Public link</th></tr></thead>
                <tbody>
                  {(postings || []).map((p) => (
                    <tr key={p.id}>
                      <td><Link to={'/hiring/postings/' + p.id} style={{ ...LINK, fontWeight: 600 }}>{p.title}</Link>
                        <div style={{ color: 'var(--hq-muted)', fontSize: 12 }}>{[p.content.location, p.content.employment_type].filter(Boolean).join(' · ') || '—'}</div></td>
                      <td><span style={postingPill(p.status)}>{p.status}</span></td>
                      <td>{p.applications}{p.unseen > 0 && <span style={{ ...appPill('new'), marginLeft: 8 }}>{p.unseen} unread</span>}</td>
                      <td>{p.scans || 0}</td>{/* @@JOB_SHARE_v111@@ QR / flyer / short-link scans */}
                      <td style={{ fontSize: 13 }}>{p.status === 'draft' ? <span style={{ color: 'var(--hq-muted)' }}>Not public (draft)</span>
                        : <span style={{ display: 'inline-flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}><a href={p.public_url} target="_blank" rel="noopener noreferrer" style={LINK}>{p.public_url.replace(/^https?:\/\//, '')}</a><CopyButton text={p.public_url} /></span>}</td>
                    </tr>
                  ))}
                  {postings && postings.length === 0 && <tr><td className="hq-empty" colSpan={5}>No postings yet.</td></tr>}
                </tbody>
              </table>
            </div>
          </div>
        </>
      )}
    </div>
  );
}
